import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ConcessionarioPessoaTipoVinculo } from '@tivic-team/manager-ts/dist/mob/enums/concessionario-pessoa/concessionario-pessoa-tipo-vinculo';
import { Usuario } from '@tivic-team/manager-ts/dist/seg';
import { ConcessionarioPessoaDTO } from 'app/model/dtos/mob/concessionario-pessoa.dto';
import { LocalStorageService } from 'app/services/local-storage.service';
import { ModalService } from 'app/tools/modal/modal.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { ModalDesativarComponent } from '../modal-desativar/modal-desativar.component';

@Component({
  selector: 'button-desativar',
  templateUrl: './button-desativar.component.html',
  styleUrls: ['./button-desativar.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class ButtonDesativarComponent implements OnInit {

  formGroup: FormGroup;
  titulo: string;
  concessionarioPessoaDTO: ConcessionarioPessoaDTO;
  usuario: Usuario;

  constructor(
    private _modalService: ModalService<ModalDesativarComponent>,
    private _controlContainer: ControlContainer,
    private _localStorage: LocalStorageService
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.usuario = this._localStorage.usuario;
    this.concessionarioPessoaDTO = this.formGroup.getRawValue();
    this.formGroup.get("cdUsuarioDesvinculacao").setValue(this.usuario.cdUsuario);
    this.nmTitulo;
  }

  desativar(){
    this._modalService.component(ModalDesativarComponent).open(this._controlContainer.control.value);
  }

  get nmTitulo() {
    if(this.concessionarioPessoaDTO.tpVinculo == ConcessionarioPessoaTipoVinculo.AUXILIAR) 
      return this.titulo = 'Inativar Auxiliar'

    return this.titulo = 'Inativar Representante'   
  }
}
